// Maps a routes.js `key` to the backend module key (config/modules.php on
// ecclesia-api) so an explicit users.permissions grant can open a sidebar
// item / route even when the user's role wouldn't normally include it.
// Only entries whose route key differs from the module key need listing —
// anything absent here is assumed to already match (e.g. "calendar").
const ROUTE_KEY_TO_MODULE = {
  "pastoral-care": "pastoral_care",
  "child-checkin": "child_checkin",
  "new-converts": "new_converts",
  "small-groups": "small_groups",
  "serving-teams": "serving_teams",
  "qr-codes": "qr_codes",
  "qr-checkin": "qr_codes",
  "registration-qr": "qr_codes",
  "bulk-email": "bulk_email",
  "sacramental-records": "sacramental_records",
  "audit-logs": "audit_logs",
  "all-departments": "departments",
  "all-ministries": "ministries",
  accounts: "payments",
  tithes: "payments",
  welfare: "payments",
  offerings: "payments",
  contributions: "payments",
  user: "users",
};

export function moduleKeyForRoute(routeKey) {
  return ROUTE_KEY_TO_MODULE[routeKey] || routeKey;
}

// True if the user can see/reach a route: their role is in the allow-list,
// OR they don't need a role check at all, OR they've been explicitly
// granted the matching module via the per-member permissions feature.
export function userHasRouteAccess(user, routeKey, roles) {
  if (!roles) return true;
  if (roles.includes(user?.role)) return true;
  const moduleKey = moduleKeyForRoute(routeKey);
  return Array.isArray(user?.permissions) && user.permissions.includes(moduleKey);
}
